<template>
  <div>
    <el-row>
      <el-col>
        <rabbey-toolbox filterables @filter-search="search = $event">
          <div class="mr-5">
            <el-dropdown @command="handleCommand" size="mini">
              <el-button
                type="primary"
                size="mini"
                :disabled="multipleSelection.length === 0"
              >
                Asignar
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="seller">Vendedor</el-dropdown-item>
                <el-dropdown-item command="support_seller">
                  Soporte de venta
                </el-dropdown-item>
                <el-dropdown-item command="customer_service">
                  Servicio al cliente
                </el-dropdown-item>
                <el-dropdown-item command="multi">Multiple</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </rabbey-toolbox>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rabbey-table-3
          :loading="loading"
          :data="items"
          :columns="columns"
          paginateFromApi
          :paginationApi="{
            currentPage: page,
            pageSize: limit,
            total: pageTotal
          }"
          @selection-change="handleSelectionChange"
          @update-page-size="handlePageSize"
          @update-current-page="handleCurrentPage"
        >
        </rabbey-table-3>
      </el-col>
    </el-row>

    <el-dialog
      title="Asignar vendedor"
      width="15%"
      :visible.sync="seller"
      v-loading="loadingDialog"
    >
      <el-container>
        <el-main>
          <el-form ref="seller" :model="formSeller">
            <el-form-item
              prop="sellerId"
              :rules="[
                { required: true, message: 'Campo requerido', trigger: 'blur' }
              ]"
            >
              <SellerSelector v-model="formSeller.sellerId" />
              <!-- <el-select -->
              <!--   size="mini" -->
              <!--   placeholder="Vendedor" -->
              <!--   v-model="formSeller.sellerId" -->
              <!--   filterable -->
              <!--   clearable -->
              <!--   style="width: 100%;" -->
              <!-- > -->
              <!--   <el-option -->
              <!--     v-for="(seller, index) in list_vendors" -->
              <!--     :key="index" -->
              <!--     :value="seller.value" -->
              <!--     :label="seller.label" -->
              <!--   /> -->
              <!-- </el-select> -->
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
      <span slot="footer">
        <el-button type="danger" size="mini" @click="cancelDialog('seller')"
          >Cancelar</el-button
        >
        <el-button type="primary" size="mini" @click="confirmDialog('seller')"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="Asignar soporte de ventas"
      width="15%"
      :visible.sync="support_seller"
    >
      <el-container>
        <el-main>
          <el-form ref="support_seller" :model="formSupportSeller">
            <el-form-item
              prop="supportSellerId"
              :rules="[
                { required: true, message: 'Campo requerido', trigger: 'blur' }
              ]"
            >
              <SupportSellerSelector
                v-model="formSupportSeller.supportSellerId"
              />
              <!-- <el-select -->
              <!--   v-model="formSupportSeller.supportSellerId" -->
              <!--   size="mini" -->
              <!--   placeholder="Soporte de ventas" -->
              <!--   style="width: 100%;" -->
              <!--   filterable -->
              <!--   clearable -->
              <!-- > -->
              <!--   <el-option -->
              <!--     v-for="agend in agends" -->
              <!--     :key="agend.value" -->
              <!--     :value="agend.value" -->
              <!--     :label="agend.label" -->
              <!--   /> -->
              <!-- </el-select> -->
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
      <span slot="footer">
        <el-button
          type="danger"
          size="mini"
          @click="cancelDialog('support_seller')"
          >Cancelar</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="confirmDialog('support_seller')"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="Asignar servicio al cliente"
      width="15%"
      :visible.sync="customer_service"
    >
      <el-container>
        <el-main>
          <el-form ref="customer_service" :model="formCustomerService">
            <el-form-item
              prop="customerServiceId"
              :rules="[
                { required: true, message: 'Campo requerido', trigger: 'blur' }
              ]"
            >
              <CustomerServiceSelector
                v-model="formCustomerService.customerServiceId"
              />
              <!-- <el-select -->
              <!--   v-model="formCustomerService.customerServiceId" -->
              <!--   size="mini" -->
              <!--   placeholder="Servicio al cliente" -->
              <!--   style="width: 100%;" -->
              <!-- > -->
              <!--   <el-option -->
              <!--     v-for="(customer, index) in customerServices" -->
              <!--     :key="index" -->
              <!--     :value="customer.value" -->
              <!--     :label="customer.label" -->
              <!--   /> -->
              <!-- </el-select> -->
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
      <span slot="footer">
        <el-button
          type="danger"
          size="mini"
          @click="cancelDialog('customer_service')"
          >Cancelar</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="confirmDialog('customer_service')"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="Asignacion multiple" width="15%" :visible.sync="multi">
      <el-container>
        <el-main>
          <el-form ref="multi" :model="formMulti">
            <el-form-item
              prop="customerServiceId"
              :rules="[
                { required: true, message: 'Campo requerido', trigger: 'blur' }
              ]"
            >
              <CustomerServiceSelector v-model="formMulti.customerServiceId" />
              <!-- <el-select -->
              <!--   v-model="formMulti.customerServiceId" -->
              <!--   size="mini" -->
              <!--   placeholder="Servicio al cliente" -->
              <!--   style="width: 100%;" -->
              <!-- > -->
              <!--   <el-option -->
              <!--     v-for="(customer, index) in customerServices" -->
              <!--     :key="index" -->
              <!--     :value="customer.value" -->
              <!--     :label="customer.label" -->
              <!--   /> -->
              <!-- </el-select> -->
            </el-form-item>

            <el-form-item
              prop="supportSellerId"
              :rules="[
                { required: true, message: 'Campo requerido', trigger: 'blur' }
              ]"
            >
              <SupportSellerSelector v-model="formMulti.supportSellerId" />
              <!-- <el-select -->
              <!--   v-model="formMulti.supportSellerId" -->
              <!--   size="mini" -->
              <!--   placeholder="Soporte de ventas" -->
              <!--   style="width: 100%;" -->
              <!--   filterable -->
              <!--   clearable -->
              <!-- > -->
              <!--   <el-option -->
              <!--     v-for="agend in agends" -->
              <!--     :key="agend.value" -->
              <!--     :value="agend.value" -->
              <!--     :label="agend.label" -->
              <!--   /> -->
              <!-- </el-select> -->
            </el-form-item>

            <el-form-item
              prop="sellerId"
              :rules="[
                { required: true, message: 'Campo requerido', trigger: 'blur' }
              ]"
            >
              <SellerSelector v-model="formMulti.sellerId" />
              <!-- <el-select -->
              <!--   size="mini" -->
              <!--   placeholder="Vendedor" -->
              <!--   v-model="formMulti.sellerId" -->
              <!--   filterable -->
              <!--   clearable -->
              <!--   style="width: 100%;" -->
              <!-- > -->
              <!--   <el-option -->
              <!--     v-for="(seller, index) in list_vendors" -->
              <!--     :key="index" -->
              <!--     :value="seller.value" -->
              <!--     :label="seller.label" -->
              <!--   /> -->
              <!-- </el-select> -->
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
      <span slot="footer">
        <el-button type="danger" size="mini" @click="cancelDialog('multi')"
          >Cancelar</el-button
        >
        <el-button type="primary" size="mini" @click="confirmDialog('multi')"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import SellerSelector from "@/components/Company/SellerSelector.vue";
import SupportSellerSelector from "@/components/Company/SupportSellerSelector.vue";
import CustomerServiceSelector from "@/components/Company/CustomerServiceSelector.vue";

export default {
  name: "ProspectAssignment",
  components: {
    SellerSelector,
    SupportSellerSelector,
    CustomerServiceSelector
  },
  created() {
    this.fetchProspects();
  },
  data() {
    return {
      loading: false,
      loadingDialog: false,
      items: [],
      // agends: [],
      // customerServices: [],
      multipleSelection: [],
      search: "",
      columns: [
        {
          type: "selection",
          width: 55
        },
        {
          prop: "ProspectId",
          label: "No",
          width: 80,
          sortable: true
        },
        {
          prop: "ProspectName",
          label: "Prospecto"
        },
        {
          prop: "ProspectCode",
          label: "Codigo"
        },
        {
          prop: "SellerName",
          label: "Vendedor",
          formatter: ImagePerson,
          attrs: {
            imgKey: "SellerImageUrl"
          }
        },
        {
          prop: "SupportSellerName",
          label: "Soporte de venta",
          formatter: ImagePerson,
          attrs: {
            imgKey: "SupportSellerImageUrl"
          }
        },
        {
          prop: "CustomerServiceName",
          label: "Servicio al cliente",
          formatter: ImagePerson,
          attrs: {
            imgKey: "CustomerServiceImageUrl"
          }
        }
      ],
      seller: false,
      formSeller: {
        sellerId: null
      },
      support_seller: false,
      formSupportSeller: {
        supportSellerId: null
      },
      customer_service: false,
      formCustomerService: {
        customerServiceId: null
      },
      multi: false,
      formMulti: {
        sellerId: null,
        supportSellerId: null,
        customerServiceId: null
      },
      mapForms: {
        multi: "formMulti",
        support_seller: "formSupportSeller",
        customer_service: "formCustomerService",
        seller: "formSeller"
      },
      page: 1,
      limit: 10,
      pageTotal: 0,
      lasRequest: null
    };
  },
  computed: {
    ...mapGetters({
      list_vendors: "sellers/getSellersEmployee",
      agends: "support_sellers/getSupportSellersEmployee",
      customerServices: "customer_services/getCustomerServicesEmployee"
    })
  },
  methods: {
    fetchProspects() {
      if (this.lasRequest) {
        this.lasRequest.cancel();
      }

      const axiosSource = axios.CancelToken.source();
      this.lasRequest = {
        cancel: axiosSource.cancel
      };

      this.loading = true;
      this.$http
        .get("/api/prospects/ProspectsByAssignment", {
          cancelToken: axiosSource.token,
          params: {
            Limit: this.limit,
            Page: this.page
          }
        })
        .then((resp) => {
          this.items = resp.data.Items;
          this.pageTotal = resp.data.ItemCount;
          this.lasRequest = null;
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCommand(command) {
      this[command] = true;
    },
    cancelDialog(form) {
      //console.log(form);
      this.$refs[form].resetFields();
      this[form] = false;
    },
    successDialog(form) {
      this.cancelDialog(form);
      this.$message.success("Asignacion exitosa.");
      this.fetchProspects();
    },
    confirmDialog(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.multipleSelection.length > 0) {
            this.loadingDialog = true;

            const { sellerId, supportSellerId, customerServiceId } =
              this[this.mapForms[form]];

            // console.log(sellerId, supportSellerId, customerServiceId);

            const prospects = this.multipleSelection.map((m) => ({
              ProspectId: m.ProspectId,
              SellerId: sellerId !== undefined ? sellerId : 0,
              SupportSellerId:
                supportSellerId !== undefined ? supportSellerId : 0,
              CustomerServiceId:
                customerServiceId !== undefined ? customerServiceId : 0
            }));

            const body = {
              ProspectAssignmentStructDtos: prospects
            };

            this.$http
              .post("/api/prospects/MultiAssignmentProspects", body)
              .then((resp) => {
                if (resp.data) {
                  this.successDialog(form);
                }
              })
              .catch((error) => console.error(error))
              .finally(() => (this.loadingDialog = false));
          }
        } else {
          this[form] = true;
          return false;
        }
      });
    },
    handlePageSize(limit) {
      this.limit = limit;
      this.fetchProspects();
    },
    handleCurrentPage(page) {
      this.page = page;
      this.fetchProspects();
    }
  }
};
</script>
